<template>
  <div class="gkmg-destination-order-list">
    <div class="card vx-card p-6">
      <div class="menu-section">
        <div class="header">
          <div class="icon-area">
            <img
              :src="gkmg_apointment"
              icon="FileTextIcon"
              svgClasses="h-7 w-7"
            />
          </div>
          <div class="title">入出港予定表</div>
          <vs-button
            class="report-download-button"
            color="#2D9CDB"
            @click="() => isShowDownloadReport && clickReportDownload()"
            v-show="isShowDownloadReport"
          >
            <div class="report-download-buttn-inner">
              <feather-icon
                class="mr-2"
                icon="FileTextIcon"
                svgClasses="h-5 w-5"
              />
              <span>日報ダウンロード</span>
            </div>
          </vs-button>
        </div>
        <vs-popup
          class="report-download-popup"
          title="日報ダウンロード"
          :active.sync="reportPopupActive"
        >
          <flat-pickr
            class="input"
            v-model="inputDate"
            placeholder="航海日を選択してください"
            style="width: 180px"
            :config.sync="configDayPicker"
          />
          <div class="button-area">
            <vs-button
              class="popup-button"
              color="#2D9CDB"
              @click="
                isShowDownloadReport && callDownloadReport(downloadCsvDate)
              "
              >ダウンロード</vs-button
            >
          </div>
        </vs-popup>

        <div>
          <div class="description">
            表示、編集する入出港予定表を選択してください。
          </div>
          <div class="order-list-area">
            <template>
              <div
                class="order-item"
                :class="{ 'draft-item': order.draft }"
                v-for="(order, index) in orderList"
                :key="index"
                @click="clickOrderItem(order.date)"
              >
                <div class="date-text">
                  <div class="icon-area">
                    <img
                      :src="apointment"
                      icon="FileTextIcon"
                      svgClasses="h-7 w-7"
                    />
                  </div>
                  {{ order.date }}<br />
                  予定表
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div v-show="isShowUploadCsv" class="menu-section">
        <div class="header-second">
          <div class="icon-area">
            <img
              :src="create_gkmg_apointment"
              icon="FileTextIcon"
              svgClasses="h-7 w-7"
            />
          </div>
          <div class="title">入出港予定表作成</div>
        </div>
        <div>
          <div class="description">
            作成する予定表の日付を設定して、一括取込みのファイルを選択してください。
          </div>
          <div class="menu-button-area">
            <vs-button
              class="import-button"
              color="#2D9CDB"
              :to="{ name: 'addon-gkmg-port-master-destination-order-import' }"
            >
              <span class="import-button-inner">
                <feather-icon
                  class="mr-2"
                  icon="FilePlusIcon"
                  svgClasses="h-5 w-5"
                />
                一括取り込み
              </span>
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import FileSaver from "file-saver";
import { createNamespacedHelpers } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
const { mapActions: mapActionsOfGkmgPortMasterDestinationWork } =
  createNamespacedHelpers("gkmgPortMasterDestinationWork");
const {
  mapGetters: mapGetterOfGkmgPortMaster,
  mapActions: mapActionsOfGkmgPortMaster,
} = createNamespacedHelpers("gkmgPortMaster");

// 予定表の日付
const ORDER_LIST_DATE = {
  BEFORE_DAYS: 2, // 何日前
  AFTER_DAYS: 2, // 何日後
};

export default {
  components: {
    flatPickr,
  },
  data() {
    return {
      iconOffice: require("@/assets/images/icons/lolcal/corporate_fare.svg"),
      selectedControl: null,
      orderList: [],
      reportPopupActive: false,
      inputDate: new Date(),
      configDayPicker: {
        dateFormat: "Y-m-d",
        time_24hr: true,
        defaultDate: new Date(),
        locale: Japanese,
        static: true,
        inline: true,
      },
      gkmg_apointment: require("@/assets/images/icons/gkmg-port-master/gkmg_apointment.svg"),
      create_gkmg_apointment: require("@/assets/images/icons/gkmg-port-master/create_gkmg_apointment.svg"),
      apointment: require("@/assets/images/icons/gkmg-port-master/apointment.svg"),
    };
  },
  async created() {
    for (
      let i = -1 * ORDER_LIST_DATE.BEFORE_DAYS;
      i <= ORDER_LIST_DATE.AFTER_DAYS;
      i++
    ) {
      this.orderList.push({
        date: moment(new Date()).add(i, "days").format("YYYY/MM/DD"),
        orderCount: "14",
        draft: "false",
      });
    }
  },
  async mounted() {
    if (!this.hasAddonGkmgPortMaster) return;
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";
    await this.getGkmgPortMasterAuth();
  },
  computed: {
    ...mapGetterOfGkmgPortMaster(["gkmgPortMasterAuth"]),
    isShowUploadCsv() {
      // this.gkmgPortMasterAuthは元はconst.jsのGKMG_AUTH_MASTERを見ているため、必ずPortMenu.uploadCsvを持つ
      return this.gkmgPortMasterAuth.PortMenu.uploadCsv;
    },
    isShowDownloadReport() {
      return this.gkmgPortMasterAuth.dailyReport.download;
    },
    downloadCsvDate() {
      return moment(this.inputDate).local().format("YYYYMMDD");
    },
  },
  methods: {
    ...mapActionsOfGkmgPortMaster([
      "exportDailyReports",
      "getGkmgPortMasterAuth",
    ]),
    ...mapActionsOfGkmgPortMasterDestinationWork(["setSelectedDate"]),
    clickReportDownload() {
      this.reportPopupActive = true;
    },
    clickOrderItem(date) {
      let jumpTo = "addon-gkmg-port-master-destination-work-display";
      this.setSelectedDate(date);
      this.$router.push({
        name: jumpTo,
      });
    },
    filterOrderDraftList(draftList) {
      let dateArray = Object.keys(draftList);
      dateArray = dateArray.filter((date) => {
        return moment(date).isBefore(moment().format("YYYYMMDD"));
      });
      dateArray.forEach((date) => {
        delete draftList[date];
      });
      return draftList;
    },
    displayDateText(date) {
      return date ? moment(date).format("YYYY/MM/DD") : null;
    },
    dateChipText(date) {
      let today = moment(new Date()).format("YYYYMMDD");
      let tomorrow = moment(new Date()).add(1, "days").format("YYYYMMDD");
      let dayAfterTomorrow = moment(new Date())
        .add(2, "days")
        .format("YYYYMMDD");
      if (date == today) {
        return "当日分";
      } else if (date == tomorrow) {
        return "翌日分";
      } else if (date == dayAfterTomorrow) {
        return "翌々日分";
      } else if (!date) {
        return "作成中";
      } else {
        return null;
      }
    },
    async callDownloadReport(date) {
      let payload = {
        date: date,
      };
      this.$vs.loading();
      try {
        let res = await this.exportDailyReports(payload);
        const fileName = `日報_${date}.xlsx`;
        FileSaver.saveAs(res.data, fileName);
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "ダウンロードに失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.gkmg-destination-order-list {
  .card {
    margin-top: 30px;
  }
  .menu-section {
    margin: 10px 0px;
  }
  .header {
    display: flex;
    align-items: center;
    .icon-area {
      width: 36px;
    }
  }
  .header-second {
    display: flex;
    align-items: center;
    margin-top: 40px;
    .icon-area {
      width: 36px;
    }
  }
  .menu-button-area {
    margin: 20px 0px;
  }
  .description {
    margin-bottom: 10px;
  }
  .menu-content {
    margin-left: 0px;
  }
  .title {
    margin-top: 7px;
    font-weight: bold;
  }
  .order-list-area {
    display: flex;
  }
  .order-item {
    border: solid 1px $pm-blue;
    border-radius: 8px;
    padding: 16px 16px 16px 16px;
    margin-right: 10px;
    width: 127px;
    height: 104px;

    cursor: pointer;
    &-empty {
      cursor: default;
      background: $pm-paper-white;
      border-width: 0px;
      .empty-text {
        color: $pm-slightly-light-gray;
      }
      .item-file-icon {
        color: white;
      }
    }
  }
  .draft-item {
    background: #e2f0fd;
  }
  .order-item-upper {
    display: flex;
    margin-bottom: 15px;
    height: 21px;
  }
  .blue-chip-text {
    color: $pm-white;
    background: $pm-blue;
    padding: 0px 12px;
    border-radius: 12px;
    margin-left: auto;
  }
  .gray-chip-text {
    color: $pm-white;
    background: $pm-gray;
    padding: 0px 12px;
    border-radius: 12px;
    margin-left: auto;
  }
  .item-file-icon {
    color: $pm-blue;
    margin: 5px 0px;
  }
  .order-count-text {
    margin-top: 25px;
  }
  .download-area {
    display: flex;
    margin-top: 15px;
    &:hover {
      color: $pm-blue;
      transition: 0.2s;
    }
  }
  .date-text {
    text-align: left;
    font-weight: bold;
    font-size: 14px;
    height: 50px;
  }
  .import-button-inner {
    display: flex;
    align-items: center;
  }
  .report-download-popup {
    .vs-popup {
      width: 400px !important;
    }
    .vs-popup--content {
      text-align: center;
    }
    .button-area {
      margin-top: 15px;
    }
    .flatpickr-input {
      display: none;
    }
    .flatpickr-day.selected,
    .flatpickr-day.nextMonthDay.selected,
    .flatpickr-day.prevMonthDay.selected {
      background: $pm-blue !important;
      border-color: $pm-blue !important;
      &:hover,
      &:focus {
        background: $pm-blue !important;
        border-color: $pm-blue !important;
      }
    }
  }
}
</style>
